export function fmtTime(s: number): string {
  const m = Math.floor(s / 60)
  return `${String(m).padStart(2,'0')}:${String(s % 60).padStart(2,'0')}`
}

interface Participante {
  id: string
  nome: string
}

type RecState = 'idle' | 'recording' | 'paused-rec' | 'uploading' | 'done'

interface AoVivoSidebarProps {
  parts: Participante[]
  presentes: Set<string>
  togglePresente: (nome: string) => void
  recState: RecState
  recSecs?: number
  pendingCount?: number
  transcribedCount?: number
  isMeet?: boolean
}

export default function AoVivoSidebar({ parts, presentes, togglePresente, recState, recSecs, pendingCount = 0, transcribedCount = 0, isMeet }: AoVivoSidebarProps) {
  return (
    <div className="flex-1 flex flex-col overflow-y-auto">
      <div className="p-4 border-b border-white/5 flex-1">
        <p className="text-[11px] tracking-[0.09em] uppercase text-[#999] font-bold mb-3">Participantes</p>
        {parts.length === 0 ? (
          <p className="text-[11px] text-[#444] italic">Nenhum cadastrado.</p>
        ) : (
          <div className="flex flex-col gap-1">
            {parts.map(p => {
              const presente = presentes.has(p.nome)
              return (
                <button key={p.id} onClick={() => togglePresente(p.nome)}
                  className="flex items-center gap-2 px-3 py-2 rounded-lg text-left cursor-pointer border-none transition-colors"
                  style={{ background: presente ? 'rgba(79,127,114,0.15)' : 'rgba(255,255,255,0.03)' }}>
                  <span className="w-4 h-4 rounded flex items-center justify-center shrink-0 transition-colors"
                    style={{ background: presente ? 'var(--color-verde)' : 'transparent', border: presente ? 'none' : '1px solid rgba(255,255,255,0.15)' }}>
                    {presente && <span className="material-symbols-outlined text-white text-[11px]">check</span>}
                  </span>
                  <span className="text-[12px] transition-colors" style={{ color: presente ? '#f0f0f0' : '#888' }}>{p.nome}</span>
                </button>
              )
            })}
          </div>
        )}
      </div>

      {/* Gravação / Meet — indicador automático */}
      <div className="p-4 shrink-0">
        {isMeet ? (
          <>
            <p className="text-[11px] tracking-[0.09em] uppercase text-[#999] font-bold mb-3">Google Meet</p>
            <div className="flex items-center gap-2 text-[11px] text-hero">
              <span className="material-symbols-outlined text-sm">video_call</span>
              Transcrição automática
            </div>
            <p className="text-[9px] text-[#333] mt-2">Disponível após encerrar a reunião no Meet</p>
          </>
        ) : (
          <>
            <p className="text-[11px] tracking-[0.09em] uppercase text-[#999] font-bold mb-3">Gravação</p>
            {recState === 'idle' && (
              <p className="text-[11px] text-[#444]">Aguardando microfone...</p>
            )}
            {recState === 'recording' && (
              <div className="flex items-center gap-2 text-[11px]" style={{ color: 'var(--color-vermelho)' }}>
                <span className="w-2 h-2 rounded-full animate-pulse" style={{ background: 'var(--color-vermelho)' }} />
                Gravando
              </div>
            )}
            {recState === 'paused-rec' && (
              <div className="flex items-center gap-2 text-[11px] text-[#555]">
                <span className="w-2 h-2 rounded-full bg-[#444]" />
                Pausado
              </div>
            )}
            {recState === 'uploading' && (
              <div className="flex items-center gap-2 text-[11px] text-[#888]">
                <span className="material-symbols-outlined animate-spin text-sm">progress_activity</span>
                Salvando segmento...
              </div>
            )}
            {recState === 'done' && (
              <p className="flex items-center gap-1.5 text-[11px]" style={{ color: 'var(--color-verde)' }}>
                <span className="material-symbols-outlined text-sm">check_circle</span>
                Gravação salva
              </p>
            )}
            {pendingCount > 0 && (
              <div className="flex items-center gap-1.5 mt-2 text-[11px]" style={{ color: 'var(--color-dourado)' }}>
                <span className="material-symbols-outlined text-sm">cloud_off</span>
                {pendingCount} segmento{pendingCount > 1 ? 's' : ''} pendente{pendingCount > 1 ? 's' : ''}
              </div>
            )}
            {transcribedCount > 0 && (
              <div className="flex items-center gap-1.5 mt-2 text-[11px]" style={{ color: 'var(--color-verde)' }}>
                <span className="material-symbols-outlined text-sm">check_circle</span>
                {transcribedCount} segmento{transcribedCount > 1 ? 's' : ''} transcrito{transcribedCount > 1 ? 's' : ''}
              </div>
            )}
            <p className="text-[9px] text-[#333] mt-2">Upload automático a cada 5 min</p>
          </>
        )}
      </div>
    </div>
  )
}
